import { css } from "styled-components";
import { Grid } from "../../components/CharacterCardGrid";
import { BladeContent } from "../../../../components/BladeContent";
import { Card, CardTitle } from "../../../../components/Card";
import { Media } from "../../../../components/Media";
import { AspectRatio } from "../../../../components/AspectRatio";
export const riotProductSkin = (chroma, palette) => css `
  padding: ${chroma.spacers.bladeEdge.topLarge} 0 ${chroma.spacers.bladeEdge.bottomLarge};

  & {
    position: relative;
  }

  ${BladeContent} {
    position: relative;
  }

  ${Grid} {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-gap: ${chroma.spacers.variable.m};

    ${chroma.mediaQueries.tabletDown} {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  ${Card} {
    cursor: pointer;

    ${AspectRatio} {
      overflow: hidden;
    }

    ${CardTitle} {
      margin-top: -1px;
      padding: 13px 16px;
      background-color: ${palette.bladebg3};
      color: ${palette.bladetext3};
      overflow: hidden;
      white-space: nowrap;
      ${chroma.typography.display8};
      font-weight: 700;
    }

    :hover {
      ${CardTitle} {
        background-color: ${palette.bladebg3_hover};
        transition: background-color 0.2s ease;
      }
      ${Media} {
        transform: scale(1.1);
        transition: transform 0.2s ease;
      }
    }
  }
`;
//# sourceMappingURL=index.js.map